import React from "react";
import "../ThirdPartyRiskManagement.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import { Link } from "react-router-dom";

import {
    FiChevronRight,
    FiCheckCircle,
    FiShield,
    FiUsers,
    FiFileText,
    FiAlertTriangle,
    FiDatabase,
    FiLock,
    FiTrendingUp,
    FiSearch,
    FiSettings
} from "react-icons/fi";


const ThirdPartyRiskManagement = () => {

    return (

        <>

            <Header />

            <div className="tprm-page">


                {/*=====================================================
                        HERO SECTION
                ======================================================*/}

                <section className="tprm-hero">


                    <div className="container">


                        <div className="tprm-hero-content">


                            <span className="tprm-tag">

                                THIRD PARTY RISK MANAGEMENT

                            </span>



                            <h1>

                                Managing Vendor Risks Through
                                <span> Secure Risk Intelligence</span>

                            </h1>



                            <p>

                                Saivari Fintech helps banks, NBFCs, payment
                                providers, insurance companies, and fintech
                                organizations identify, assess, and manage
                                third-party risks with structured governance,
                                compliance monitoring, and intelligent risk
                                management solutions.

                            </p>



                            <div className="tprm-buttons">


                                <a
                                    href="/contact"
                                    className="tprm-primary-btn"
                                >
                                    Get Consultation
                                </a>


                                {/* <Link
                                    to="/services"
                                    className="tprm-secondary-btn"
                                >
                                    Explore Services
                                </Link> */}


                            </div>


                        </div>


                    </div>


                </section>







                {/*=====================================================
                        BREADCRUMB
                ======================================================*/}


                <section className="tprm-breadcrumb">


                    <div className="container">


                        <Link to="/">
                            Home
                        </Link>


                        <FiChevronRight />


                        <Link to="/services">
                            Solutions
                        </Link>


                        <FiChevronRight />


                        <span>
                            Third Party Risk Management
                        </span>


                    </div>


                </section>








                {/*=====================================================
                        OVERVIEW
                ======================================================*/}


                <section className="tprm-overview">


                    <div className="container tprm-grid">


                        <div className="tprm-content">


                            <span className="section-tag">
                                RISK MANAGEMENT
                            </span>



                            <h2>

                                Strengthening Vendor Governance
                                <span> & Operational Resilience</span>

                            </h2>



                            <p>

                                Financial organizations depend on multiple
                                technology partners, vendors, and service
                                providers. Managing these relationships requires
                                continuous monitoring, compliance validation,
                                and risk assessment.

                            </p>



                            <p>

                                Our Third Party Risk Management solutions help
                                organizations evaluate vendors, monitor risks,
                                maintain regulatory alignment, and improve
                                business resilience.

                            </p>




                            <div className="tprm-checks">


                                <div>

                                    <FiCheckCircle />

                                    <span>
                                        Vendor Risk Assessment
                                    </span>

                                </div>



                                <div>

                                    <FiCheckCircle />

                                    <span>
                                        Regulatory Compliance Monitoring
                                    </span>

                                </div>



                                <div>

                                    <FiCheckCircle />

                                    <span>
                                        Third Party Security Evaluation
                                    </span>

                                </div>



                                <div>

                                    <FiCheckCircle />

                                    <span>
                                        Continuous Risk Monitoring
                                    </span>

                                </div>


                            </div>


                        </div>







                        <div className="tprm-dashboard">


                            <div className="tprm-card">

                                <FiUsers />

                                <h3>
                                    Vendor Management
                                </h3>

                                <span>
                                    Partner Monitoring
                                </span>

                            </div>



                            <div className="tprm-card">

                                <FiShield />

                                <h3>
                                    Risk Assessment
                                </h3>

                                <span>
                                    Security Evaluation
                                </span>

                            </div>




                            <div className="tprm-card">

                                <FiFileText />

                                <h3>
                                    Compliance
                                </h3>

                                <span>
                                    Regulatory Controls
                                </span>

                            </div>




                            <div className="tprm-card">

                                <FiDatabase />

                                <h3>
                                    Risk Analytics
                                </h3>

                                <span>
                                    Data Insights
                                </span>

                            </div>



                        </div>


                    </div>


                </section>








                {/*=====================================================
                        CAPABILITIES
                ======================================================*/}


                <section className="tprm-capabilities">


                    <div className="container">


                        <div className="section-heading">


                            <span className="section-tag">
                                OUR CAPABILITIES
                            </span>


                            <h2>

                                Complete Third Party
                                <span> Risk Solutions</span>

                            </h2>


                            <p>

                                We help organizations build secure vendor
                                ecosystems through proactive risk identification
                                and governance.

                            </p>


                        </div>






                        <div className="tprm-service-grid">



                            <div className="tprm-service-card">

                                <div className="tprm-icon">
                                    🔍
                                </div>

                                <h3>
                                    Vendor Assessment
                                </h3>

                                <p>
                                    Evaluate vendor security, operational
                                    capabilities, and compliance readiness.
                                </p>

                            </div>





                            <div className="tprm-service-card">

                                <div className="tprm-icon">
                                    🛡
                                </div>

                                <h3>
                                    Security Risk Review
                                </h3>

                                <p>
                                    Identify cybersecurity risks across third
                                    party relationships.
                                </p>

                            </div>





                            <div className="tprm-service-card">

                                <div className="tprm-icon">
                                    📋
                                </div>

                                <h3>
                                    Compliance Monitoring
                                </h3>

                                <p>
                                    Ensure vendors follow required regulatory
                                    and security standards.
                                </p>

                            </div>





                            <div className="tprm-service-card">

                                <div className="tprm-icon">
                                    📊
                                </div>

                                <h3>
                                    Risk Reporting
                                </h3>

                                <p>
                                    Generate insights and reports for better
                                    risk-based decision making.
                                </p>

                            </div>





                            <div className="tprm-service-card">

                                <div className="tprm-icon">
                                    🔐
                                </div>

                                <h3>
                                    Data Protection
                                </h3>

                                <p>
                                    Protect sensitive business and customer
                                    information.
                                </p>

                            </div>





                            <div className="tprm-service-card">

                                <div className="tprm-icon">
                                    ⚙
                                </div>

                                <h3>
                                    Risk Automation
                                </h3>

                                <p>
                                    Automate monitoring workflows and improve
                                    operational efficiency.
                                </p>

                            </div>



                        </div>


                    </div>


                </section>








                {/*=====================================================
                        CHALLENGES
                ======================================================*/}


                <section className="tprm-challenges">


                    <div className="container">


                        <div className="section-heading">


                            <span className="section-tag">
                                CHALLENGES WE SOLVE
                            </span>


                            <h2>

                                Reducing Third Party
                                <span> Business Risks</span>

                            </h2>


                        </div>




                        <div className="challenge-grid">



                            <div>

                                <FiAlertTriangle />

                                <h3>
                                    Vendor Risks
                                </h3>

                                <p>
                                    Identify weaknesses before they impact
                                    business operations.
                                </p>

                            </div>




                            <div>

                                <FiLock />

                                <h3>
                                    Security Threats
                                </h3>

                                <p>
                                    Strengthen protection against third-party
                                    security vulnerabilities.
                                </p>

                            </div>




                            <div>

                                <FiTrendingUp />

                                <h3>
                                    Compliance Gaps
                                </h3>

                                <p>
                                    Maintain regulatory alignment with continuous
                                    monitoring.
                                </p>

                            </div>


                        </div>


                    </div>


                </section>








                {/*=====================================================
                        PROCESS
                ======================================================*/}


                <section className="tprm-process">


                    <div className="container">


                        <div className="section-heading">


                            <span className="section-tag">
                                RISK ASSESSMENT PROCESS
                            </span>


                            <h2>

                                Our Structured
                                <span> Risk Approach</span>

                            </h2>


                        </div>






                        <div className="tprm-process-grid">



                            <div className="tprm-process-card">

                                <div className="process-number">
                                    01
                                </div>

                                <h3>
                                    Vendor Identification
                                </h3>

                                <p>
                                    Understand third-party relationships and
                                    classify vendor risk levels.
                                </p>

                            </div>




                            <div className="tprm-process-card">

                                <div className="process-number">
                                    02
                                </div>

                                <h3>
                                    Risk Evaluation
                                </h3>

                                <p>
                                    Assess security, compliance, and operational
                                    risks.
                                </p>

                            </div>




                            <div className="tprm-process-card">

                                <div className="process-number">
                                    03
                                </div>

                                <h3>
                                    Monitoring & Reporting
                                </h3>

                                <p>
                                    Continuously monitor vendor performance and
                                    emerging risks.
                                </p>

                            </div>


                        </div>


                    </div>


                </section>








                {/*=====================================================
                        BENEFITS
                ======================================================*/}


                <section className="tprm-benefits">


                    <div className="container">


                        <div className="section-heading">


                            <span className="section-tag">
                                BUSINESS BENEFITS
                            </span>


                            <h2>

                                Why Choose Our
                                <span> Risk Solutions</span>

                            </h2>


                        </div>






                        <div className="benefit-grid">



                            <div>

                                <FiShield />

                                <h3>
                                    Better Security
                                </h3>

                                <p>
                                    Reduce vendor-related security risks.
                                </p>

                            </div>



                            <div>

                                <FiCheckCircle />

                                <h3>
                                    Compliance Ready
                                </h3>

                                <p>
                                    Improve regulatory governance.
                                </p>

                            </div>



                            <div>

                                <FiSearch />

                                <h3>
                                    Risk Visibility
                                </h3>

                                <p>
                                    Gain better understanding of vendor risks.
                                </p>

                            </div>



                            <div>

                                <FiSettings />

                                <h3>
                                    Operational Control
                                </h3>

                                <p>
                                    Build efficient risk management processes.
                                </p>

                            </div>



                        </div>


                    </div>


                </section>




            </div>


            <Footer />


        </>

    );

};


export default ThirdPartyRiskManagement;